import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, inject, input, output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { finalize } from 'rxjs';
import { environment } from 'src/environments/environment';
import { InfoboxService } from '../infobox/infobox.service';
import { LoaderService } from '../loader/loader.service';
import { NavbarModule } from '../navbar/navbar.module';

@Component({
	selector: 'app-import-csv',
	standalone: true,
	imports: [NavbarModule, MatButtonModule],
	templateUrl: './import-csv.component.html',
	styleUrl: './import-csv.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImportCsvComponent {
	readonly requestUrl = input.required<string>();
	readonly method = input.required<'post' | 'patch' | 'put'>();

	readonly successUpload = output<void>();

	readonly isDragging = signal(false);
	readonly uploadedFile = signal<File>(null);

	private readonly httpClient = inject(HttpClient);
	private readonly infoboxService = inject(InfoboxService);
	private readonly loaderService = inject(LoaderService);

	onDragOver(event: DragEvent): void {
		event.preventDefault();
		this.isDragging.set(true);
	}

	onDragLeave(event: DragEvent): void {
		event.preventDefault();
		this.isDragging.set(false);
	}

	onDrop(event: DragEvent): void {
		event.preventDefault();
		this.isDragging.set(false);
		if (event.dataTransfer?.files.length) {
			const file = event.dataTransfer.files[0];
			this.checkAndSetCSVFile(file);
		}
	}

	onFileSelected(event: Event): void {
		const input = event.target as HTMLInputElement;
		if (input.files?.length) {
			const file = input.files[0];
			this.checkAndSetCSVFile(file);
		}
	}

	uploadCSV(): void {
		if (!this.uploadedFile()) {
			return;
		}

		this.loaderService.show();

		const formData = new FormData();
		formData.append('csv_file', this.uploadedFile());

		this.httpClient[this.method()](`${environment.apiUrl}${this.requestUrl()}`, formData)
			.pipe(finalize(() => this.loaderService.hide()))
			.subscribe(() => {
				this.uploadedFile.set(null);
				this.successUpload.emit();
				this.infoboxService.success('Pomyślnie zaktualizowano dane.');
			});
	}

	private checkAndSetCSVFile(file: File): void {
		const isCSVFile = file.type === 'text/csv' || file.name.endsWith('.csv');

		if (!!isCSVFile) {
			this.uploadedFile.set(file);
		} else {
			this.infoboxService.warning('Proszę wybrać plik CSV');
		}
	}
}
